export default {"src":"/_next/static/media/visa_secure.0e6e7b8e.svg","height":527,"width":528,"blurWidth":0,"blurHeight":0};